// extracted by mini-css-extract-plugin
export default {"form":"createpost_form__9SKzg"};